import React from 'react';
import styled from 'styled-components';
import MenuSVG from 'resources/img/menu.svg';
import NoProfileSVG from 'resources/img/no-profile.svg';
import useUser from 'state/user';
import { IMAGES_URL } from 'resources/constants/urls';
import { useHistory } from 'react-router-dom';
import { BRAND_GREEN_PRIMARY, BRAND_GREEN_VIBRANT } from 'resources/constants/colors';

const Bar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 24px;
    background: linear-gradient(140deg, ${BRAND_GREEN_PRIMARY} 0%, ${BRAND_GREEN_VIBRANT} 100%);
    border-radius: 0 0 20px 20px;
    margin: 0 -20px 16px;
`;

const MenuBtn = styled.button`
    background: rgba(255, 255, 255, 0.25);
    border: none;
    border-radius: 50%;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
    img { width: 22px; height: 22px; opacity: 0.85; }
    &:active { opacity: 0.6; }
`;

const AvatarBtn = styled.button`
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 2.5px solid rgba(255, 255, 255, 0.85);
    overflow: hidden;
    background: rgba(255, 255, 255, 0.55);
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    font-weight: 800;
    color: #2a3d00;
    flex-shrink: 0;
    -webkit-tap-highlight-color: transparent;
    &:active { opacity: 0.75; }
    img { width: 100%; height: 100%; object-fit: cover; }
`;

const getInitials = (name = '') =>
    name.split(' ').slice(0, 2).map(n => n[0]?.toUpperCase() ?? '').join('');

const SubpageTopBar = ({ toggleMenu, title }) => {
    const [user] = useUser();
    const history = useHistory();
    const name = user?.current?.name ?? '';
    const profileImg = user?.current?.profileImg;

    return (
        <Bar>
            <MenuBtn onClick={toggleMenu} aria-label="Menú">
                <img src={MenuSVG} alt="Menú" />
            </MenuBtn>
            {title && (
                <span style={{
                    fontSize: 20,
                    fontWeight: 700,
                    color: '#1a2700',
                    fontFamily: "'Playfair Display', serif",
                }}>
                    {title}
                </span>
            )}
            <AvatarBtn onClick={() => history.push('/perfil')} aria-label="Ver perfil">
                {profileImg ? (
                    <img src={`${IMAGES_URL}${profileImg}`} alt="Perfil" />
                ) : name ? (
                    getInitials(name)
                ) : (
                    <img src={NoProfileSVG} alt="Perfil" />
                )}
            </AvatarBtn>
        </Bar>
    );
};

export default SubpageTopBar;
